import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Frontier Link';
}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/app.component.ts